import type { PromotionGroup } from '@/domain/Promotion.ts';
import type { DiscoverPromotionsDrawerProps } from '../DiscoverPromotionsDrawer.tsx';
import PromoLineItem from './PromotionLineItem.tsx';
import styles from './PromotionGroupItems.module.scss';
import type { CurrencyFormatConfig } from '@/domain/Pricing.ts';

export type PromotionGroupItemsProps = CurrencyFormatConfig & {
  promotions: PromotionGroup[];
  productInfo: DiscoverPromotionsDrawerProps['product'];
};

export default function PromotionGroupItems({
  promotions,
  productInfo,
  currencyCode,
  locale
}: PromotionGroupItemsProps) {
  // take the first from the group!
  const productPromotions =
    promotions.length > 0 ? promotions[0].promotions : [];

  return (
    <div class={styles.items}>
      <ul class={styles.list}>
        {productPromotions.map((promo, index) => (
          <PromoLineItem
            promotion={promo}
            productInfo={productInfo}
            currencyCode={currencyCode}
            locale={locale}
            separator={index < productPromotions.length - 1}
          />
        ))}
      </ul>
    </div>
  );
}
